/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tiles.vue?vue&type=template&id=35806056&scoped=true&"
import script from "./tiles.vue?vue&type=script&lang=js&"
export * from "./tiles.vue?vue&type=script&lang=js&"
import style0 from "./tiles.vue?vue&type=style&index=0&id=35806056&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35806056",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VProgressCircular,VSheet})
